const  ENDPOINT = "https://internalapi.skillsuprise.com/";
export default ENDPOINT;